<template>
	<span class="mx-3 md:mx-6 border-l h-9 my-auto"></span>
</template>

<script setup></script>

<style lang="scss" scoped></style>
